import { render, staticRenderFns } from "./ImgPlusStatic.vue?vue&type=template&id=b1987c72&scoped=true&"
import script from "./ImgPlusStatic.vue?vue&type=script&lang=js&"
export * from "./ImgPlusStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1987c72",
  null
  
)

export default component.exports